module.exports = __webpack_public_path__ + "img/SmartYunzhou.933c8f91.jpg";